import { render } from "./NavigationBarLink.vue?vue&type=template&id=1f795571&scoped=true&ts=true"
import script from "./NavigationBarLink.vue?vue&type=script&lang=ts"
export * from "./NavigationBarLink.vue?vue&type=script&lang=ts"

import "./NavigationBarLink.vue?vue&type=style&index=0&id=1f795571&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f795571"]])

export default __exports__